<template>
  <div>
    <Table
      :columns="columns"
      :data="getOrderedProducts"
      :is-accessible="true"
      @view="redirectToProductPage"
      :is-selectable="true"
      @newSelectedRows="$emit('newSelectedRows', $event)"
    >
      <template #name="{ row }">
        <div class="ml-3 flex flex-col">
          <div class="flex items-center">
            <div class="h-10 w-10 shrink-0">
              <img class="h-10 w-10" :src="row.imageUrl" alt="" />
            </div>
            <div class="ml-4">
              <div class="text-gray-900 font-medium">
                {{ row.title }}
              </div>
              <div class="text-gray-500">
                <p v-if="variantsHaveSamePrice(row)">{{ formatPrice(cheapestVariantPrice(row)) }}</p>
                <p v-else>
                  {{ formatPrice(cheapestVariantPrice(row)) }} - {{ formatPrice(mostExpensiveVariantPrice(row)) }}
                </p>
              </div>
              <div v-if="row.referenceId">
                <span class="font-medium">Reference ID</span>
                : {{ row.referenceId }}
              </div>
              <div>
                <span class="font-medium">Estaly ID</span>
                : {{ row.id }}
              </div>
            </div>
          </div>
          <ProductStatusSpanList class="mt-2" :product="row" />
        </div>
      </template>

      <template #category="{ row }">
        <ProductCategoryDisplay :product="row" />
      </template>

      <template #action="{ row }">
        <ProductActionButton v-if="row.source !== 'offline'" :product="row" />
      </template>
    </Table>
  </div>
</template>

<script>
import ProductActionButton from "@/views/products/list/content/actions/ProductActionButton.vue";
import ProductStatusSpanList from "@/views/products/list/content/status/ProductStatusSpanList.vue";
import { Table, formatPrice } from "@estaly/ui";
import ProductCategoryDisplay from "@/views/products/list/content/actions/ProductCategoryDisplay.vue";
export default {
  components: {
    Table,
    ProductCategoryDisplay,
    ProductActionButton,
    ProductStatusSpanList,
  },
  props: ["products"],

  computed: {
    columns() {
      return [
        {
          label: "Nom",
          field: "name",
          slot: "name",
        },
        {
          label: "Catégorie",
          field: "category",
          slot: "category",
        },
        {
          label: "Action",
          field: "contractStatus",
          slot: "action",
        },
      ];
    },
    getOrderedProducts() {
      return [...this.products].sort((a, b) => (a.enabled < b.enabled ? 1 : -1));
    },
  },
  methods: {
    formatPrice,
    redirectToProductPage(product) {
      this.$router.push(`/products/${product.id}`);
    },

    cheapestVariantPrice(product) {
      if (!product.variants) return 0;
      return Math.min(...product.variants.map((v) => v.price ?? Infinity)) || 0;
    },

    mostExpensiveVariantPrice(product) {
      if (!product.variants || product.variants.length === 0) return 0;
      return Math.max(...product.variants.map((v) => v.price ?? 0)) || 0;
    },

    variantsHaveSamePrice(product) {
      if (!product.variants || product.variants.length === 0) return true;
      const prices = product.variants.map((v) => v.price ?? 0);
      return prices.every((price) => price === prices[0]);
    },
  },
};
</script>
